export enum AppTheme {
  BHS = 'BHS',
  CUREWIKI = 'Curewiki',
  PCE = 'PCE',
  PEC = 'PEC',
  YES_WE_CANCER = 'YesWeCancer',
}
